import React, { useEffect } from "react";
import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import useDeviceType from "../../../global/Hooks/useDeviceType";
import { persianDigitWithSeprator } from "../components/PersianDigit";

function ChartRenderer({ data, title, useSeparator = false }) {
  
  const toPersianDigits = (str) => {
    if (!str) return "";
    return str.toString().replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d]);
  };

  const formatValue = (value) => {
    if (useSeparator) {
      return persianDigitWithSeprator(value);
    }
    return toPersianDigits(value);
  };

  const deviceType = useDeviceType();

  return (
    <ResponsiveContainer width="100%" minHeight="22rem">
      <LineChart
        width={"auto"}
        height={"17.5rem"}
        data={data}
        margin={{
          top: 5,
          right: deviceType != "mobile" ? 10 : 0,
          left: deviceType != "mobile" ? 20 : -25,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey="name"
          fontSize={deviceType != "mobile" ? "10px" : "8px"}
          angle={0}
          tickMargin={deviceType != "mobile" ? 5 : 1}
          tickFormatter={(value) => toPersianDigits(value)}
        />
        <YAxis
          fontSize={"14px"}
          tickMargin={deviceType != "mobile" ? 50 : 10}
          tickFormatter={(value) => formatValue(value)}
        />
        <Tooltip
          content={({ active, payload, label }) => {
            if (active && payload && payload.length) {
              return (
                <div
                  style={{
                    background: "#fff",
                    color: "#1E6AFD",
                    padding: "10px",
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                  }}
                >
                  {payload.map((entry, i) => (
                    <div key={i}>
                      {entry.name}: {formatValue(entry.value)}
                    </div>
                  ))}
                </div>
              );
            }
            return null;
          }}
        />
        <Line
          type="monotone"
          name={title}
          dataKey="value"
          stroke="#3592FB"
          activeDot={{ r: 8 }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
}

export default ChartRenderer;
